import * as yup from 'yup'

const password = yup
  .string()
  .required('Password is required')
  .min(8, 'Minimum of 8 characters is required')
  .matches(/[0-9]/, 'Password requires a number')
  .matches(/[a-z]/, 'Password requires a lowercase letter')
  .matches(/[A-Z]/, 'Password requires an uppercase letter')
  .matches(/^\S*$/, 'Password cannot contain spaces.')

const verifyString = (name: string, label: string = `${name} must match`) =>
  yup
    .string()
    .oneOf([yup.ref(name)], label)
    .required(`Verify ${name} is required.`)

const validation = { password, verifyString }

export default validation
